/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree_agb').is(':checked') && $('#agree_widerruf').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.");
        return false;
      }
    });
    $('body').on('click', '[name="contact-submit"]', function() {
      if ($('#agree_contact').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.");
        return false;
      }
    });
});
*/

var atc = (btn, variantId) => {
  var formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };
  btn.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  fetch('/cart/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      btn.removeAttribute('disabled');
      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: { variantId },
            quantity: 1,
          },
        })
      );
    })
    .catch((error) => {
      btn.removeAttribute('disabled');
      console.error('Error:', error);
    });
};

/**
 * Cart Drawer Recommendations Web Component
 * Loads and displays product recommendations in the cart drawer
 */
var CartDrawerRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
  }

  async connectedCallback() {
    // Prevent loading recommendations multiple times
    if (this.hasLoaded) {
      return;
    }

    // Listen for cart refresh events to reload recommendations
    this.handleCartRefresh = this.loadRecommendations.bind(this);
    document.documentElement.addEventListener('cart:refresh', this.handleCartRefresh);

    await this.loadRecommendations();
  }

  disconnectedCallback() {
    // Clean up event listener when component is removed
    document.documentElement.removeEventListener('cart:refresh', this.handleCartRefresh);
  }

  async loadRecommendations() {
    var productToFindRecommendations = this.cartItemIds[0];
    var productRecommendationsUrl = this.getAttribute('data-base-url');

    if (!productToFindRecommendations) {
      this.innerHTML = '';
      return;
    }

    try {
      var response = await fetch(
        `${productRecommendationsUrl}?product_id=${productToFindRecommendations}&limit=10&intent=complementary&section_id=recommendations`
      );

      if (!response.ok) {
        console.error('Failed to fetch recommendations');
        return;
      }

      var html = await response.text();
      
      // Replace the entire content instead of appending
      this.innerHTML = html;
      this.hasLoaded = true;

      // Add event listeners for AJAX add to cart buttons if they exist
      this.querySelectorAll('[ajax-atc]').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          var variantId = el.dataset.variantId;
          atc(el, variantId);
        });
      });
    } catch (error) {
      console.error('Error loading cart recommendations:', error);
    }
  }

  get cartItemIds() {
    var items = this.getAttribute('data-cart-items');
    if (!items) return [];
    
    return items
      .split(',')
      .map((item) => Number(item))
      .filter(id => !isNaN(id) && id > 0);
  }
};

if (!window.customElements.get('cart-drawer-recommendations')) {
  window.customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}

/* Animation for announcement bar */
document.addEventListener('DOMContentLoaded', function () {
  const announcements = document.querySelectorAll('.AnnouncementBar__Content');
  let currentIndex = 0;
  const mobileBreakpoint = 1140;

  function toggleAnnouncement() {
    if (window.innerWidth <= mobileBreakpoint) {
      const nextIndex = (currentIndex + 1) % announcements.length;

      // Start fading out the current announcement
      announcements[currentIndex].style.opacity = '0';

      // Start fading in the next announcement slightly before the current one is fully faded out
      setTimeout(() => {
        announcements[currentIndex].classList.remove('active');
        announcements[nextIndex].classList.add('active');
        announcements[nextIndex].style.opacity = '1';
        currentIndex = nextIndex;
      }, 200); // Adjust this timing for optimal overlap
    }
  }

  // Initial setup
  if (window.innerWidth <= mobileBreakpoint) {
    announcements[currentIndex].classList.add('active');
    announcements[currentIndex].style.opacity = '1';
  }

  // Toggle every 5 seconds
  setInterval(toggleAnnouncement, 5000);

  // Handle window resize
  window.addEventListener('resize', function () {
    if (window.innerWidth > mobileBreakpoint) {
      announcements.forEach((a) => {
        a.classList.remove('active');
        a.style.opacity = '1';
      });
    } else {
      announcements.forEach((a, index) => {
        if (index === currentIndex) {
          a.classList.add('active');
          a.style.opacity = '1';
        } else {
          a.classList.remove('active');
          a.style.opacity = '0';
        }
      });
    }
  });
});

/**
 *  * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 *
 */

try {
  document.addEventListener('DOMContentLoaded', function () {
    window.__pagefly_helper_store__ &&
      window.__pagefly_helper_store__.subscribe(function (res) {
        console.log('triggered pagefly helper store', res);

        fetch('/cart.json').then((cart) => {
          document.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: !0,
              detail: {
                variant: res.variant_id,
                quantity: 1,
              },
            })
          );
          const cartDrawer = document.getElementById('sidebar-cart');
          cartDrawer.ariaHidden = false;
        });
      });
  });
} catch (e) {
  console.warn(e);
}

/**
 * Cart Add Free Product Web Component
 * Automatically adds a free product to cart when threshold is reached
 */
var CartAddFreeProduct = class extends HTMLElement {
  async connectedCallback() {
    var cartUrl = this.getAttribute('data-base-url');
    var fetchResponse = await fetch(''.concat(cartUrl, '.js?add-free-product'), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    this.cart = await fetchResponse.json();

    var qtyInTheCart = 0;
    var cartUpdates = {};
    var updateNeeded = false;

    for (var i = 0; i < this.cart.items.length; i++) {
      if (this.cart.items[i].id === this.variantId) {
        qtyInTheCart = this.cart.items[i].quantity;
        break;
      }
    }

    // Remove product if cart only contains this item
    if (this.cart.items.length === 1 && qtyInTheCart > 0) {
      cartUpdates = { [this.variantId]: 0 };
      updateNeeded = true;
    }

    // Remove product if below threshold
    if (this.cart.items.length >= 1 && qtyInTheCart > 0 && this.eligibleTotal < this.threshold) {
      cartUpdates = { [this.variantId]: 0 };
      updateNeeded = true;
    } 
    // Add product if above threshold and not yet in cart
    else if (this.cart.items.length >= 1 && qtyInTheCart !== 1 && this.eligibleTotal >= this.threshold) {
      cartUpdates = { [this.variantId]: 1 };
      updateNeeded = true;
    }

    if (updateNeeded) {
      var headers = new Headers({ 'Content-Type': 'application/json' });
      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ updates: cartUpdates }),
      };

      fetch(cartUrl + '/update.js', request).then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
      });
    }
  }

  get variantId() {
    return Number(this.getAttribute('data-variant-id'));
  }
  
  get threshold() {
    return Number(this.getAttribute('data-threshold'));
  }

  get eligibleTotal() {
    return Number(this.getAttribute('data-eligible-total'));
  }
};

if (!window.customElements.get('cart-add-free-product')) {
  window.customElements.define('cart-add-free-product', CartAddFreeProduct);
}
